module.exports = __webpack_public_path__ + "static/media/satagro.49d322db.jpg";